import { type MessageMention, api } from '@here/api'
import { createEffect, createResource, createSignal } from 'solid-js'
import { createStore } from 'solid-js/store'
import { userId } from '../auth'
import { handleDeleteMessageMention, handleGetMessageMentions } from './resources'

export function useMessageMention() {
	const [messageMentions, setMessageMentions] = createStore<MessageMention[]>([])

	const [messageMentionsResource] = createResource(userId, handleGetMessageMentions, {
		initialValue: [],
	})

	const [deleteMessageMention, setDeleteMessageMention] = createSignal<string>()

	const [deleteMessageMentionResource] = createResource(
		deleteMessageMention,
		handleDeleteMessageMention,
	)

	createEffect(() => {
		if (userId()) {
			api()
				.channel('message_mention_changes') // fixed typo: was 'message_metion'
				.on(
					'postgres_changes',
					{
						event: 'INSERT',
						schema: 'public',
						table: 'message_mention',
						filter: `user_id=eq.${userId()}`,
					},
					(payload) => {
						const mention = payload.new as MessageMention
						// Assuming `mention.id` is the unique key
						setMessageMentions((prev) => [...prev, mention])
					},
				)
				.subscribe()
		}
	})

	createEffect(() => {
		const mesageMentions = messageMentionsResource()
		setMessageMentions(mesageMentions)
	})

	const messageMentionChannelMap = () =>
		messageMentions.reduce<Record<string, MessageMention[]>>((prev, curr) => {
			if (prev[curr.channel_id]) {
				prev[curr.channel_id] = [...prev[curr.channel_id], curr]
			} else {
				prev[curr.channel_id] = [curr]
			}
			return prev
		}, {})

	createEffect(() => {
		if (deleteMessageMentionResource.state === 'ready') {
			setMessageMentions((messages) =>
				messages.filter((m) => m.id !== deleteMessageMentionResource()),
			)
		}
	})

	return {
		messageMentions,
		setMessageMentions,
		messageMentionChannelMap,
		deleteMessageMentionResource,
		setDeleteMessageMention,
	}
}
